import React from 'react';
import { useLayoutContext } from 'contexts/LayoutContext';
import api from 'lib/trpcClient';
import { CurrencyCode } from 'further-types/lp/vehicle';
import TransferFeesContent from './TransferFeesContent';

const TransferFees: React.FC<{
  partnerTransferId: string;
  baseCurrency: CurrencyCode;
  onNext: () => void;
  onPrevious: () => void;
  stepper: React.ReactNode;
}> = ({ partnerTransferId, baseCurrency, onNext, onPrevious, stepper }) => {
  const { selectedVehicleId } = useLayoutContext();

  const [feesData] = api.partnerTransfers.getFees.useSuspenseQuery(
    {
      partnerTransferId,
      vehicleId: selectedVehicleId ?? '',
    },
    {
      staleTime: 0,
      gcTime: 0,
    },
  );

  return (
    <TransferFeesContent
      partnerTransferId={partnerTransferId}
      fees={feesData.fees}
      baseCurrency={baseCurrency}
      onNext={onNext}
      onPrevious={onPrevious}
      stepper={stepper}
    />
  );
};

export default TransferFees;
